import { Select } from "antd";
import type { LabelValue } from "~types/labelValue";
import type { EntitySelectOption } from "../types";

type Props = {
  onChange?: (values: LabelValue[] | null) => void;
  value?: LabelValue[];
  disabled: boolean;
  options: EntitySelectOption[];
};

const OptionRender = (option: EntitySelectOption) => {
  const { label, gender, status, standard, discipline, ageGroup } = option;
  const subtitle = [gender, ageGroup, discipline, standard].filter((item) => !!item).join(" | ");
  const isActiveOption = status === "ACTIVE";

  return (
    <>
      <div>
        <span style={{ opacity: isActiveOption ? 1 : 0.7 }}>{label}</span>
        {!isActiveOption && <span style={{ paddingLeft: "4px" }}>{`| ${status}`}</span>}
      </div>
      {subtitle && <div style={{ opacity: isActiveOption ? 1 : 0.7 }}>{subtitle}</div>}
    </>
  );
};

const SelectPermissionEntities = ({ onChange, value, disabled, options }: Props) => (
  <Select
    allowClear
    autoClearSearchValue={false}
    value={value}
    mode="multiple"
    showSearch
    options={options}
    disabled={disabled}
    labelInValue
    optionFilterProp="label"
    onChange={onChange}
    listHeight={300}
    optionRender={(option) => <OptionRender {...option.data} />}
  />
);

export default SelectPermissionEntities;
